module.exports = __webpack_public_path__ + "media/src/fonts/GothamPro-Bold-2c6f2ca60db58ce41cc7c621f471b214.woff";